import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Grid, Box } from "@mui/material";
import LocalShipping from "@mui/icons-material/LocalShipping";
import DirectionsBoat from "@mui/icons-material/DirectionsBoat";
import Flight from "@mui/icons-material/Flight";
import Train from "@mui/icons-material/Train";
import Inventory2 from "@mui/icons-material/Inventory2";
import AirForm from "./forms/AirForm";
import OceanForm from "./forms/OceanForm";
import RoadForm from "./forms/RoadForm";
import IntermodalForm from "./forms/IntermodalForm";
import ProjectCargoForm from "./forms/ProjectCargoForm";

import DashboardNavbar from "../../../../../../examples/Navbars/DashboardNavbar";
import Footer from "../../../../../../examples/Footer";
import DashboardLayout from "../../../../../../examples/LayoutContainers/DashboardLayout";
import CrudService from "services/cruds-service";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { CrmPageHeader, CRM_COLORS, crmCardSx } from "../shared/CrmUi";
import { ReadOnlyBanner, ReadOnlyFieldset } from "components/ReadOnlyLock";

const TRANSPORT_TYPES = [
    { value: "Road", label: "Road", icon: LocalShipping },
    { value: "Ocean", label: "Ocean", icon: DirectionsBoat },
    { value: "Air", label: "Air", icon: Flight },
    { value: "Intermodal", label: "Intermodal", icon: Train },
    { value: "ProjectCargo", label: "Project Cargo", icon: Inventory2 },
];

const CreateOpportunity = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const opportunityId = searchParams.get("id");

    const [selectedTransportType, setSelectedCarrier] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    // An existing opportunity opens read-only, like the TMS pages; "Edit" unlocks the form.
    const [readOnlyMode, setReadOnlyMode] = useState(Boolean(opportunityId));
    const passedTransport = location.state?.selectedTransportType || "";

    useEffect(() => {
        if (opportunityId) return;
        if (!passedTransport) return;
        setSelectedCarrier(passedTransport);
    }, [opportunityId, passedTransport]);


    useEffect(() => {
        if (opportunityId) {
            setIsEditing(true);
            fetchOpportunityDetails(opportunityId);
        }
        setReadOnlyMode(Boolean(opportunityId));
    }, [opportunityId]);

    const fetchOpportunityDetails = async (id) => {
        try {
            const response = await CrudService.getOpportunityById(id);
            const opportunityData = response.data.attributes;
            setSelectedCarrier(opportunityData.selectedTransportType);
        } catch (error) {
            console.error("Error fetching opportunity details:", error);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {!isEditing && (
                <MDBox pt={3}>
                    <CrmPageHeader
                        title="Create Opportunity"
                        subtitle="Select a transport type and fill in the required details"
                    />
                    {/* Taşıma türü seçimi (eski açılır menünün yerine seçim kartları) */}
                    <Grid container spacing={1.5} mb={1}>
                        {TRANSPORT_TYPES.map(({ value, label, icon: Icon }) => {
                            const selected = selectedTransportType === value;
                            return (
                                <Grid item xs={6} sm={4} md={2.4} key={value}>
                                    <MDBox
                                        component="button"
                                        type="button"
                                        onClick={() => setSelectedCarrier(value)}
                                        sx={{
                                            ...crmCardSx,
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1.25,
                                            px: 2,
                                            py: 1.5,
                                            cursor: "pointer",
                                            fontFamily: "inherit",
                                            textAlign: "left",
                                            borderColor: selected ? CRM_COLORS.navy : CRM_COLORS.cardBorder,
                                            boxShadow: selected ? `inset 0 0 0 1px ${CRM_COLORS.navy}` : "none",
                                            "&:hover": { borderColor: CRM_COLORS.blue },
                                        }}
                                    >
                                        <MDBox
                                            sx={{
                                                width: 36,
                                                height: 36,
                                                borderRadius: "8px",
                                                display: "grid",
                                                placeItems: "center",
                                                flexShrink: 0,
                                                color: selected ? CRM_COLORS.white : CRM_COLORS.navy,
                                                background: selected ? CRM_COLORS.navy : "#EEF2F6",
                                            }}
                                        >
                                            <Icon sx={{ fontSize: "20px !important" }} />
                                        </MDBox>
                                        <MDTypography sx={{ fontSize: 14, fontWeight: 600, color: CRM_COLORS.text }}>
                                            {label}
                                        </MDTypography>
                                    </MDBox>
                                </Grid>
                            );
                        })}
                    </Grid>
                </MDBox>
            )}
            {readOnlyMode && (
                <MDBox pt={3}>
                    <ReadOnlyBanner
                        message="This opportunity is in read-only view. Click Edit to make changes."
                        onEdit={() => setReadOnlyMode(false)}
                        mb={0}
                    />
                </MDBox>
            )}
            <ReadOnlyFieldset readOnly={readOnlyMode}>
            <Grid container spacing={0} justifyContent="flex-start" sx={{ width: "100%", m: 0, p: 0 }}>
                <Grid item xs={12} sx={{
                    width: "100%",
                    maxWidth: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    ml: 0,
                    pl: 0
                }}>
                    {selectedTransportType === "Road" && (
                        <RoadForm selectedTransportType={selectedTransportType}/>
                    )}
                    {selectedTransportType === "Ocean" && (
                        <OceanForm selectedTransportType={selectedTransportType}/>
                    )}
                    {selectedTransportType === "Air" && (
                        <AirForm selectedTransportType={selectedTransportType}/>
                    )}
                    {selectedTransportType === "Intermodal" && (
                        <IntermodalForm selectedTransportType={selectedTransportType}/>
                    )}
                    {selectedTransportType === "ProjectCargo" && (
                        <ProjectCargoForm selectedTransportType={selectedTransportType}/>
                    )}
                </Grid>
            </Grid>
            </ReadOnlyFieldset>
            <Box sx={{ mt: selectedTransportType ? 0 : 40 }}>
                <Footer />
            </Box>
        </DashboardLayout>
    );
};

export default CreateOpportunity;
